import React from "react";
import { createRoot } from "react-dom/client";
import { DOM_ROOT_ID } from "./constants";

import "./customtheme.scss";
import App from "./App";

// Expose utilities for console debugging
import OfflineStore from "./util/OfflineStore";
import OfflineSync from "./util/OfflineSync";
window.OfflineStore = OfflineStore;
window.OfflineSync = OfflineSync;

const container = document.getElementById(DOM_ROOT_ID || "root");

const url = new URL(window.location.href);
["nocache", "manscan"].forEach(param => {
	if (url.searchParams.has(param)) {
		url.searchParams.get(param).toLowerCase() === "false"
			? localStorage.removeItem(param)
			: localStorage.setItem(param, "true");
		url.searchParams.delete(param);
	}
});
if (url.toString() !== window.location.href) {
	window.history.pushState(null, null, url);
}

const root = createRoot(container);
root.render(
	// <React.StrictMode>
		<App tab="home" />
	// </React.StrictMode>
);

// In dev, unregister any leftover service workers to prevent reload loops
if ("serviceWorker" in navigator && process.env.NODE_ENV !== "production") {
	navigator.serviceWorker.getRegistrations().then(regs => regs.forEach(r => r.unregister()));
}

// Register offline service worker for background sync (production only — dev server conflicts with SW lifecycle)
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
	window.addEventListener("load", () => {
		navigator.serviceWorker.register("/offline-sw.js")
			.then((registration) => {
				console.warn("[ServiceWorker] Registered:", registration.scope);

				// Register for background sync if supported
				if ("sync" in registration) {
					registration.sync.register("offline-sync").catch(() => {
						// Background sync not supported or permission denied
					});
				}

				// SW message listener is managed by OfflineManager.Init()
			})
			.catch((error) => {
				console.warn("[ServiceWorker] Registration failed:", error);
			});
	});
}

